export default function () {

    let accordions = document.querySelectorAll('[data-accordion]');

    for (let i = 0; i < accordions.length; i++) {

        let accordion = accordions[i]
        let accordionData = accordion.getAttribute('data-accordion')

        accordionData = JSON.parse(accordionData)

        // get the accordion data...
        let header = accordionData.header;
        let body = accordionData.body;

        //find the elements...
        let aHeader = accordions[i].querySelector(header);
        let aBody = accordions[i].querySelector(body);

        // PATWAK: Add a css variable for each accordion to say how tall it is when open. We may or may not use it later.
        let aBodyHeight = aBody.scrollHeight
        aBody.style.setProperty('--accordion-max-height', `${aBodyHeight}px`)

        aHeader?.addEventListener('click', function (event) {
            event.preventDefault();

            aBody.classList.toggle('is-open');
            aHeader.classList.toggle('is-open');
        })
    }

    // accordian block
    $('.AccordionBlock-toggle').on('click', function (e) {
        e.preventDefault()
        let $this = $(this)
        // PATWAK NOTE: Also added toggle on the AccordionBlock-toggle so we can style it differently based on the state.
        // I would've prefered having only that since span.plus-minus-toggle is a child of AccordionBlock-toggle, but don't want to have to
        // restyle all instances of the accordion, so left for legacy reasons.
        $this.toggleClass('is-collapsed')
        $this.find('.plus-minus-toggle').toggleClass('is-collapsed')
        let $parentBlock = $this.closest('.AccordionBlock')
        $parentBlock.find('.AccordionBlock-content').toggleClass('is-collapsed')
        $parentBlock.find('.AccordionBlock-image--container').toggleClass('is-collapsed')

        jAwn.trigger($this, `toggleAccordion`)
        // also trigger the custom event on the document so we can recalculate the max-height of the accordion blocks
        jAwn.trigger(document, 'recalculateAccordionBlockHeights')
    });

    // PATWAK: This is the same as the above, but for the "other type of" accordions. Check the height of each AccordionBlock-content and add as css var.
    // No damn idea why we have two that works pretty much exactly the same... Not using jquery here, good ole fashioned js.
    const calcAccordionBlockHeights = () => {
        let accordionBlocks = document.querySelectorAll('.AccordionBlock')
        for (let i = 0; i < accordionBlocks.length; i++) {
            let accordionBlock = accordionBlocks[i]
            let accordionContent = accordionBlock.querySelector('.AccordionBlock-content')
            let accordionContentHeight = accordionContent.scrollHeight
            accordionContent.style.setProperty('--accordion-max-height', `${accordionContentHeight}px`)
        }
    }
    // PATWAK: we also need a way to recalculate the max-height of the accordion on a custom event, so we can have accordion in accordion and make it grow correctly
    // we'll create the new custom event with jQuery since we have it, and we'll trigger it on the document.
    jAwn.on(document, 'recalculateAccordionBlockHeights', function () {
        calcAccordionBlockHeights()
    })

    // PATWAK: Call the function to calculate the heights of the accordion blocks on pageload.
    calcAccordionBlockHeights()
}